import { render, staticRenderFns } from "./IndexInfoItem.vue?vue&type=template&id=b0729250&scoped=true&"
import script from "./IndexInfoItem.vue?vue&type=script&lang=js&"
export * from "./IndexInfoItem.vue?vue&type=script&lang=js&"
import style0 from "./IndexInfoItem.vue?vue&type=style&index=0&id=b0729250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0729250",
  null
  
)

export default component.exports